<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  [class.d-none]="isShowCampaignStatusInGateway"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (onSelectAll)="onSelectAll($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="!tw-px-4 !tw-py-2 tw-text-center">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- CreationLocation -->
        <td>
          <span class="tw-text-sm">
            {{
              item?.creationLocation | enumToText : CreationLocationEnumValues
            }}</span
          >
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <td class="sticky-td">
          <a
            (click)="onCampaignStatusInGateway(item.id, item.title)"
            class="btn btn-sm tw-ml-3"
            matTooltip="{{ 'common.campaignStatusInGateway' | translate }}"
          >
            <i class="mdi mdi-note-check mdi-20px text-info"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'SmartSmsCampaign'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!--CampaignStatusInGateway-->
<ng-container *ngIf="isShowCampaignStatusInGateway">
  <app-campaign-status-in-gateway
    [campaignId]="campaignId"
    [campaignTitle]="campaignTitle"
    (closePage)="onHideCampaignStatusInGateway()"
  ></app-campaign-status-in-gateway>
</ng-container>
